
const digest = '9239a221145e9e282d0c60fd7164ee779957a30f1e1255044281f2ce4a2f4a4f';
const classes = {"item":"_item_1ahsa_1","content":"_content_1ahsa_11","title":"_title_1ahsa_15","subtitle":"_subtitle_1ahsa_21","date":"_date_1ahsa_27","controls":"_controls_1ahsa_33"};
const css = `._item_1ahsa_1 {
  background-color: #fff;
  border-radius: 15px;
  padding: 13px 14px;
  display: flex;
  flex-direction: row;
  text-decoration: none;
  box-shadow: -3px 7px 13px 0 rgba(68, 70, 105, 0.15);
  margin-bottom: 16px;
}
._item_1ahsa_1 ._content_1ahsa_11 {
  flex-grow: 1;
  padding-top: 5px;
}
._item_1ahsa_1 ._content_1ahsa_11 ._title_1ahsa_15 {
  color: #3c3f9c;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}
._item_1ahsa_1 ._content_1ahsa_11 ._subtitle_1ahsa_21 {
  color: #212357;
  font-size: 12px;
  font-weight: 400;
  margin-top: 8px;
}
._item_1ahsa_1 ._content_1ahsa_11 ._date_1ahsa_27 {
  font-weight: 400;
  font-size: 12px;
  color: #9ea0a5;
  margin-top: 11px;
}
._item_1ahsa_1 ._controls_1ahsa_33 {
  display: flex;
  align-items: center;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  